import ComponentCircleLoader from 'components/Loaders/ComponentCircleLoader';
import React, { useEffect, useState } from 'react';
import { CommonGrid } from 'styledComponents/common';



import { DashBoardCommonGrid } from '../../DashBoardNew/dashBoardNewStyles';
import JobsStatusBarChart from './JobsStatusBarChart';
import TodaysAttendance from './TodaysAttendance';
import TopPerformers from './TopPerformers';
import ButtonHelpTooltip from 'components/Tooltip/ButtonHelpTooltip';


const DashBoardSecondSection = ({
    attendanceData,
    selectedOrganization,
    getDashboardAttendance,
    attendanceIsLoading,
    getJobInfoCustom,
    jobsCustomIsloading,
    jobsCustom,
    getDashboardPerformers,
    performersIsLoading,
    topPerformers,
    history,
}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const orgType = selectedOrganization?.type || 'operation';
    const isOperationType = orgType === 'operation';


    if (loading) {
        return <ComponentCircleLoader />;
    }

    return (
        <DashBoardCommonGrid responsiveBreakpoint="1290px" responsiveColumns="1fr" columns="1.5fr 3fr" gap="20px">
            <CommonGrid columns="1fr" gap="20px">
                <TodaysAttendance attendanceData={attendanceData} getDashboardAttendance={getDashboardAttendance} attendanceIsLoading={attendanceIsLoading} selectedOrganization={selectedOrganization} history={history} />
            </CommonGrid>
            <CommonGrid
                columns="repeat(2, minmax(0, 1fr))"
                gap="20px"
                alignItem="stretch"
                responsiveBreakpoint="612px"
                responsiveColumns="1fr"
                mobileColumns="1fr"
            >
                <TopPerformers
                    topPerformers={topPerformers}
                    isLoading={performersIsLoading}
                    getDashboardPerformers={getDashboardPerformers}
                    selectedOrganization={selectedOrganization}
                />
                <JobsStatusBarChart
                    selectedOrganization={selectedOrganization}
                    getJobInfoCustom={getJobInfoCustom}
                    jobsCustomIsloading={jobsCustomIsloading}
                    jobsCustom={jobsCustom}
                    isOperationType={isOperationType}
                />
            </CommonGrid>
        </DashBoardCommonGrid>
    );
};

export default DashBoardSecondSection;